const generateRoutePath = pathStringArray => {
  let objectPath = {}
  pathStringArray.forEach(str => objectPath[str.split("/")[0]] = `/${str}`)
  return objectPath
}

export default generateRoutePath